export const RewardCatalogListColConfig = [
  {
    name_of_db_column: 'name',
    label_of_column: 'Name',
    order_of_column: 1,
    filterable: true
  },
  {
    name_of_db_column: 'type',
    label_of_column: 'Type',
    order_of_column: 2,
    filterable: true
  },
  {
    name_of_db_column: 'rewardId',
    label_of_column: 'Reward ID',
    order_of_column: 3,
    filterable: true
  },
  {
    name_of_db_column: 'rewardAcceptance',
    label_of_column: 'Reward Acceptance',
    order_of_column: 4,
    filterable: true
  },
  {
    name_of_db_column: 'startDate',
    label_of_column: 'Start Date',
    order_of_column: 5,
    filterVariant: 'dateRange',
    initialSize: 330,
    filterable: true
  },
  {
    name_of_db_column: 'endDate',
    label_of_column: 'End Date',
    order_of_column: 6,
    filterVariant: 'dateRange',
    initialSize: 330,
    filterable: true
  },
  {
    name_of_db_column: 'updatedDate',
    label_of_column: 'Updated Date',
    order_of_column: 7,
    filterVariant: 'dateRange',
    initialSize: 330,
    filterable: true
  },
  {
    name_of_db_column: 'updatedBy',
    label_of_column: 'Updated By',
    order_of_column: 8,
    filterable: true
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'Status',
    order_of_column: 9,
    filterable: true
  },
  {
    name_of_db_column: 'inventory',
    label_of_column: 'Inventory',
    order_of_column: 10,
    filterable: false,
    hideSortIcon: true
  },
  {
    name_of_db_column: 'reportUrl',
    label_of_column: 'Report',
    order_of_column: 11,
    filterable: false,
    hideSortIcon: true
  }
];
